import { useContext, useMemo } from "react";

import { ToastContext, type Toast } from "../providers/toast.context";

type ToastData = Omit<Toast, "type">;

export const useToast = () => {
	const { addToast } = useContext(ToastContext);

	return useMemo(
		() => ({
			toastInfo: (data: ToastData) => {
				addToast({
					...data,
					type: "info",
				});
			},
			toastSuccess: (data: ToastData) => {
				addToast({
					...data,
					type: "success",
				});
			},
			toastWarning: (data: ToastData) => {
				addToast({
					...data,
					type: "warning",
				});
			},
			toastError: (data: ToastData) => {
				addToast({
					...data,
					type: "error",
				});
			},
		}),
		[addToast],
	);
};
